import { render, staticRenderFns } from "./MainTable.vue?vue&type=template&id=1ded820c&scoped=true&"
import script from "./MainTable.vue?vue&type=script&lang=js&"
export * from "./MainTable.vue?vue&type=script&lang=js&"
import style0 from "./MainTable.vue?vue&type=style&index=0&id=1ded820c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded820c",
  null
  
)

export default component.exports